import Vue from 'vue'
import VueRouter from 'vue-router'

/*解决重复进入路由时报错*/
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
};

Vue.use(VueRouter);

const routes = [
    {
        // 首页
        path: "/",
        name: "index",
        component: () => import("@/view/index/index.vue")
    },
    {
        // 个人
        path: "/user",
        name: "user",
        component: () => import("@/view/user/user.vue")
    },
    {
        // 登录
        path: "/login",
        name: "login",
        component: () => import("@/view/login/login.vue")
    },
    {
        // 注册
        path: "/register",
        name: "register",
        component: () => import("@/view/register/register.vue")
    },
    {
        // 团队
        path: "/team",
        name: "team",
        component: () => import("@/view/team/team.vue")
    },
    {
        // 交易中心
        path: "/tradeCenter",
        name: "tradeCenter",
        component: () => import("@/view/tradeCenter/tradeCenter.vue")
    },
    {
        // 交易记录
        path: "/tradeList",
        name: "tradeList",
        component: () => import("@/view/tradeList/tradeList.vue")
    },
    {
        // 提币
        path: "/withdraw",
        name: "withdraw",
        component: () => import("@/view/withdraw/withdraw.vue")
    },
    {
        // 安全中心
        path: "/safeCenter",
        name: "safeCenter",
        component: () => import("@/view/safeCenter/safeCenter.vue")
    },
    {
        // 账户记录
        path: "/accoundRecord",
        name: "accoundRecord",
        component: () => import("@/view/accoundRecord/accoundRecord.vue")
    },
    {
        // 通知列表
        path: "/noticeList",
        name: "noticeList",
        component: () => import("@/view/noticeList/noticeList.vue")
    },
    {
        // 通知公告详情
        path: "/announcement",
        name: "announcement",
        component: () => import("@/view/announcement/announcement.vue")
    },
    {
        // 每日日分享
        path: "/share",
        name: "share",
        component: () => import("@/view/share/share.vue")
    },
    {
        // 分享
        path: "/shareList",
        name: "shareList",
        component: () => import("@/view/shareList/shareList.vue")
    },
    {
        // 实名认证
        path: "/certification",
        name: "certification",
        component: () => import("@/view/certification/certification.vue")
    },
    {
        // 交易密码
        path: "/dealPwd",
        name: "dealPwd",
        component: () => import("@/view/dealPwd/dealPwd.vue")
    },
    {
        // 登录密码
        path: "/dealLoginPwd",
        name: "dealLoginPwd",
        component: () => import("@/view/dealLoginPwd/dealLoginPwd.vue")
    },
    {
        // 充币
        path: "/recharge",
        name: "recharge",
        component: () => import("@/view/recharge/recharge.vue")
    },
    {
        // 邀请码
        path: "/inviteCode",
        name: "inviteCode",
        component: () => import("@/view/inviteCode/inviteCode.vue")
    },
    {
        // 上传图片
        path: "/uploadImage",
        name: "uploadImage",
        component: () => import("@/view/uploadImage/uploadImage.vue")
    },
    {
        // 我的矿机
        path: "/myMiner",
        name: "myMiner",
        component: () => import("@/view/myMiner/myMiner.vue")
    },
    {
        // 转账
        path: "/transfer",
        name: "transfer",
        component: () => import("@/view/transfer/transfer.vue")
    },
    {
        // 拼团收益
        path: "/pintuan",
        name: "pintuan",
        component: () => import("@/view/pintuan/pintuan.vue")
    },
    {
        // 分享图片
        path: "/shareImg",
        name: "shareImg",
        component: () => import("@/view/shareImg/shareImg.vue")
    },
    {
        // C2C 交易页
        path: "/c2cIndex",
        name: "c2cIndex",
        component: () => import("@/view/c2c/c2cIndex.vue")
    },
    {
        // 我的 C2C
        path: "/myC2c",
        name: "myC2c",
        component: () => import("@/view/c2c/myC2c.vue")
    },
    {
        // C2C 订单
        path: "/c2cOrder",
        name: "c2cOrder",
        component: () => import("@/view/c2c/c2cOrder.vue")
    },
    {
        // 支付方式
        path: "/payType",
        name: "payType",
        component: () => import("@/view/payType/payType.vue")
    },
    {
        // 完成页
        path: "/complete",
        name: "complete",
        component: () => import("@/view/complete/complete.vue")
    },
    {
        // 聊天页
        path: "/chatView",
        name: "chatView",
        component: () => import("@/view/chatView/chatView.vue")
    },
    {
        // 申诉页
        path: "/allege",
        name: "allege",
        component: () => import("@/view/allege/allege.vue")
    },
];

const router = new VueRouter({
    routes
});

export default router
